<template>
    <div class="cursor-pointer"
         v-on:click="openProviderWindow()">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "auth-button",
    data: function () {
        return {
            checkCompletedInterval: null,
        };
    },
    mounted () {
        window.addEventListener('message', this.onMessage, false);
        this.checkCompletedInterval = setInterval(this.checkCompleted, 500)
    },
    beforeDestroy () {
        window.removeEventListener('message', this.onMessage);
        if (this.checkCompletedInterval)
            this.checkCompletedInterval = clearInterval(this.checkCompletedInterval);
    },
    methods: {
        checkCompleted: function () {
            if (localStorage.getItem('login') === 'completed')
            {
                localStorage.removeItem('login');
                this.$emit('completed');
                if (this.checkCompletedInterval)
                    this.checkCompletedInterval = clearInterval(this.checkCompletedInterval)
            }
        },
        onMessage (e) {
            if (e.origin !== window.origin || !e.data.status)
                return;

            this.$emit('completed');
        },
        openProviderWindow: function () {
            const newWindow = this.openWindow(document.location, 'message');
            Vue.axios.get('/auth/social/init/' + this.provider)
                .then((response) => {
                    newWindow.location.href = response.data;
                });
        },

        openWindow: function(url, title, options = {}) {
            if (typeof url === 'object') {
                options = url
                url = ''
            }

            options = { url, title, width: 600, height: 720, ...options }

            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
            const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
            const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height

            options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
            options.top = ((height / 2) - (options.height / 2)) + dualScreenTop

            const optionsStr = Object.keys(options).reduce((acc, key) => {
                acc.push(`${key}=${options[key]}`)
                return acc
            }, []).join(',')

            const newWindow = window.open(url, title, optionsStr)

            if (window.focus) {
                newWindow.focus()
            }

            return newWindow
        },
    },
    props: {
        provider: {
            required: true,
            type: String,
        },
    },
}
</script>